import React from 'react';

// Editorial page header: left-aligned, ivory, generous margins, closed by a
// single hairline. No centering, no ornament.
const PageHero = ({ eyebrow, title, subtitle }) => (
  <header className="border-b border-secondary-200">
    <div className="max-w-6xl mx-auto px-6 sm:px-10 lg:px-12 pt-24 pb-16 lg:pt-36 lg:pb-24">
      {eyebrow && (
        <p className="text-[11px] font-semibold text-primary-700 uppercase tracking-[0.2em] mb-7">
          {eyebrow}
        </p>
      )}
      <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl font-normal text-secondary-900 leading-[1.1] tracking-tight max-w-4xl">
        {title}
      </h1>
      {subtitle && (
        <p className="text-lg md:text-xl text-secondary-600 mt-8 leading-relaxed max-w-2xl">
          {subtitle}
        </p>
      )}
    </div>
  </header>
);

export default PageHero;
